/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_schedule_simple': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 15',
    data: '<path pid="0" data-name="Path 17827" d="M4.688 7.5H2.813V5.625h1.875zm3.75-1.875H6.563V7.5h1.875zm3.75 0h-1.875V7.5h1.875zm-7.5 2.813H2.813v1.875h1.875zm3.75 0H6.563v1.875h1.875zm3.75 0h-1.875v1.875h1.875zm-7.5 2.813H2.813v1.875h1.875zm3.75 0H6.563v1.875h1.875zM3.75 2.813a.937.937 0 00.938-.937V.938a.938.938 0 00-1.875 0v.938a.937.937 0 00.937.937zM15 1.875V15H0V1.875h2.344a1.406 1.406 0 002.813 0h4.687a1.406 1.406 0 002.813 0zm-.937 2.813H.938v9.375h13.125zM11.25 2.813a.937.937 0 00.938-.937V.938a.938.938 0 00-1.875 0v.938a.937.937 0 00.937.937z" _fill="#6a6e76"/>'
  }
})
